import { DataService } from 'src/app/services/data.service';
import { User } from './../../../../interfaces/user';
import { AuthService } from './../../../../services/auth.service';
import { Payment } from '../../../../interfaces/transactions';
import { BreadCrumb } from './../../../../interfaces/main';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ICreateOrderRequest } from 'ngx-paypal';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent implements OnInit {

  paypalConfig: any;
  creditsValues: number[];
  pricePerCredit: any;

  user: User;

  creditsForm: FormGroup;

  breadcrumbs: BreadCrumb[] = [{
    link: 'Home',
    url: ['/']
  },{
    link: 'My Account',
    url: ['/profile']
  }]

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private auth: AuthService,
    private data: DataService
  ) { }

  async ngOnInit() {
    try{
      const res = await this.data.getSettings('configs').toPromise();

      if(!res){
        return;
      }

      const ps = res.data;

      if(!ps || !ps.creditsToPurchase || !ps.creditsToPurchase.length || !ps.pricePerCredit){
        throw Error('Something went wrong.');
      }

      this.creditsValues = ps.creditsToPurchase;
      this.pricePerCredit = ps.pricePerCredit;

      this.user = await this.auth.getUser();

      this.breadcrumbs.push({
        link: this.user.name,
        url: ['/profile']
      })
      this.breadcrumbs.push({
        link: 'Balance'
      })

      this.creditsForm = this.fb.group({
        type: new FormControl('PayPal', [Validators.required]),
        currency: new FormControl('USD', [Validators.required]),
        credits: new FormControl(_.first(this.creditsValues), [Validators.required])
      })
    }catch({message}){
      this.toastr.error(message);
    }
  }

  continue(){
    this.initConfig(this.creditsForm.value);
  }

  initConfig(v){
    const currency = v.currency;
    const amount = _.toString(v.credits * this.pricePerCredit);

    console.log(v);

    if(!currency || !amount){
      throw Error('Something went wrong.');
    }

    this.paypalConfig = {
      currency: currency,
      clientId: 'AWgzKdj2dTCGz2EGQGDchzj5k0FnZtvN18_kKGKp0d0dZOTdVM18emPvbmoaFdn28OWoNZKGFAmyps9Z',
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [
          {
            amount: {
              currency_code: currency,
              value: amount,
              breakdown: {
                item_total: {
                  currency_code: currency,
                  value: amount
                }
              }
            },
            items: [
              {
                name: 'BilinStudio Purchase credits',
                quantity: '1',
                category: 'DIGITAL_GOODS',
                unit_amount: {
                  currency_code: currency,
                  value: amount,
                },
              }
            ]
          }
        ]
      },
      advanced: {
        updateOrderDetails: {
          commit: true
        }
      },
      style: {
        shape: 'rect',
        label: 'pay'
      },
      onApprove: (data, actions) => {
        console.log('onApprove - transaction was approved, but not authorized', data, actions);
        actions.order.get().then(details => {
          console.log('onApprove - you can get full order details inside onApprove: ', details);
        });
      },
      onClientAuthorization: async (data) => {

        const {purchase_units} = data;

        const payment: Payment = {
          create_time: data.create_time,
          paypal_id: data.id,
          payer_id: data.payer.payer_id,
          payer_email_address: data.payer.email_address,
          status: data.status,
          update_time: data.update_time,
          amount: purchase_units[0].amount.value,
          currency: purchase_units[0].amount.currency_code,
          credits: v.credits
        }

        this.data.addPayment(payment).subscribe((res) => {
          if(res){
            this.router.navigate(['/profile']);
          }
        })
      },
      onError: err => {
        this.toastr.error(err);
      }
    };
  }
}
